module.exports = __webpack_public_path__ + "img/sld_abt_meter_t1_disable.d9f1c4a3.svg";